// Optimizaciones básicas para Arra Seguridad (compatibles con Livewire)

(function() {
    'use strict';
    
    // Solo optimizaciones esenciales que no interfieren con Livewire
    
    // Font loading optimization - básico
    function checkFontsLoaded() {
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(function() {
                document.documentElement.classList.add('fonts-loaded');
                document.documentElement.classList.remove('font-loading');
            });
        }
    }

    // Lazy loading de imágenes - simple
    function initLazyLoading() {
        if ('IntersectionObserver' in window) {
            const imageObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && entry.target.dataset.src) {
                        const img = entry.target;
                        img.src = img.dataset.src;
                        img.classList.remove('lazy');
                        imageObserver.unobserve(img);
                    }
                });
            });

            document.querySelectorAll('img[data-src]').forEach(img => {
                imageObserver.observe(img);
            });
        }
    }

    // Funciones de prefetch y service worker deshabilitadas para pruebas
    // function initPagePrefetch() { ... } - DESHABILITADO
    // function registerServiceWorker() { ... } - DESHABILITADO

    // Inicializar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            checkFontsLoaded();
            initLazyLoading();
            // initPagePrefetch(); - DESHABILITADO PARA PRUEBAS
            // registerServiceWorker(); - DESHABILITADO PARA PRUEBAS
        });
    } else {
        checkFontsLoaded();
        initLazyLoading();
        // initPagePrefetch(); - DESHABILITADO PARA PRUEBAS
        // registerServiceWorker(); - DESHABILITADO PARA PRUEBAS
    }

    // Marcar como cargado inicialmente
    document.documentElement.classList.add('font-loading');
})();
